import { getHeaders } from '@ori/presentation-http';
import axios from 'axios';

import { TRANSLATIONS_ENDPOINT } from '../constants';
import { getSafeUrl } from './getSafeUrl';

interface LocalizationResponse {
  DefaultLanguage: string;
  Translations: {
    [locale: string]: Record<string, string>;
  };
}

export const fetchTranslations = async (language: string, tenant: string, staticApiUrl: string) => {
  const url = getSafeUrl(TRANSLATIONS_ENDPOINT.replace('{tenant}', tenant), staticApiUrl);
  const {
    data: { Translations: translations = {} },
  } = await axios.get<Partial<LocalizationResponse>>(url.toString(), {
    headers: getHeaders({ currentLanguage: language, tenant }),
    validateStatus: (status) => status >= 200 && status < 500,
  });

  return translations[language] ?? {};
};
